export default function Eligible({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      className={className}
    >
      <path
        d="M6.48047 12.1911L12.0309 17.6319L23.7605 4.67188"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M22.3886 9.00867C23.1311 10.4599 23.5473 12.108 23.5473 13.8518C23.5473 19.7524 18.7661 24.5337 12.8655 24.5337C6.96484 24.5337 2.18359 19.7524 2.18359 13.8518C2.18359 7.95117 6.96484 3.16992 12.8655 3.16992C15.6386 3.16992 18.1642 4.22742 20.0598 5.9543"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
